import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DiscoveryHost } from "./OnvifScanUtils/onvifScanInterfaces";
import { hostHasNoStream } from "./OnvifScanUtils/summarizeScanHosts";

const headerSx = { fontFamily: "Mulish", fontWeight: 700, color: "#001943" };
const cellSx = { fontFamily: "Mulish", color: "#283E6D" };

/**
 * Every IP the scan turned up on the tunnel subnet — not just the ones with an
 * addable RTSP profile. Mirrors the admin network-scan "Discovered hosts" table
 * (IP · Open ports · HTTP · HTTP title / server · ONVIF).
 */
export const OnvifDiscoveredHostsTable = ({
  hosts,
}: {
  hosts: DiscoveryHost[];
}) => {
  return (
    <TableContainer component={Paper} sx={{ maxHeight: "40vh" }}>
      <Table stickyHeader size="small" aria-label="discovered hosts">
        <TableHead>
          <TableRow>
            <TableCell sx={headerSx}>IP</TableCell>
            <TableCell sx={headerSx}>Open ports</TableCell>
            <TableCell sx={headerSx}>HTTP</TableCell>
            <TableCell sx={headerSx}>HTTP title / server</TableCell>
            <TableCell sx={headerSx}>ONVIF</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {hosts.map((host) => (
            <TableRow key={host.ip} hover>
              <TableCell sx={cellSx}>{host.ip}</TableCell>
              <TableCell sx={cellSx}>
                {(host.open_ports || []).join(", ") || "—"}
              </TableCell>
              <TableCell sx={cellSx}>
                {host.http_status == null ? "—" : host.http_status}
              </TableCell>
              <TableCell sx={cellSx}>
                {host.http_title || host.http_server || "—"}
              </TableCell>
              <TableCell sx={cellSx}>
                {host.onvif_auth_status || "—"}
                {/* The reason matters: "auth_failed" alone reads as "not a
                    camera", when it usually means "a camera we lack the
                    credentials for". */}
                {host.onvif_error && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "#7A7A7A",
                      whiteSpace: "normal",
                    }}
                  >
                    {host.onvif_error}
                  </div>
                )}
                {hostHasNoStream(host) && (
                  <div
                    style={{
                      fontSize: 11,
                      color: "#B26A00",
                      whiteSpace: "normal",
                    }}
                  >
                    Logged in, but the camera returned no stream address. Add
                    it manually with its RTSP URL.
                  </div>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
